var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"payment-qiwi",style:({
    height: _vm.pixelSize + 'px',
    width: _vm.pixelSize + 'px',
    'background-size': (_vm.pixelSize * _vm.size.x) + 'px ' + (_vm.pixelSize * _vm.size.y) + 'px',
    'background-position': (_vm.pixelSize * _vm.suite[_vm.method].x) + 'px ' + (_vm.pixelSize * _vm.suite[_vm.method].y) + 'px',
    'margin-top': '5px'
  })})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f2c5e04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/PaymentQiwi.vue
// module id = null
// module chunks = 